/**
 * Linha da planilha de importação (nome, código, pontos por real) no formato do POST
 * /sale-products. Código ausente vira '' (a linha é descartada depois) em vez de 'undefined';
 * célula numérica do xlsx não tem `.replace`, então tudo passa por String antes.
 */
export const parseSaleProductRow = (item: Record<string, unknown>) => {
  const values = Object.values(item)
  const code = values[1] == null ? '' : String(values[1]).trim()
  const points = values[2] ? parseFloat(String(values[2]).replace(',', '.')) : 0

  // Nome numérico (ex.: código de barras na coluna do nome) vem como number do xlsx e o Joi pede string.
  const name = values[0] == null ? '' : String(values[0]).trim()

  return { name, code, pointsPerMoney: Number.isNaN(points) ? 0 : points }
}
